/**
 * 提供站點資訊
 */
(function(){
    const siteInfo = {};
    const {q, qa} = require('../libs/simpleQuery');


    //判斷站點
    siteInfo.isGBT = /gigabyte\.com/.test(window.location.hostname);

    const KFContainer = q('.InnerGIGABYTEContent') || q('.innergigabyteContent');
    siteInfo.KFContainer = KFContainer;

    module.exports = siteInfo;
})();